import type { ViewProps } from 'react-native'
import * as S from './validate.styles'

type ValidateProps = {
  children: string
  type: 'expiration' | 'countdown'
} & Omit<ViewProps, 'style'>

const Validate = ({ children, type, ...rest }: ValidateProps) => {
  return (
    <S.Container {...rest}>
      {type === 'expiration' ? (
        <S.TitleExpiration numberOfLines={1}>{children}</S.TitleExpiration>
      ) : (
        <S.TitleCountdown numberOfLines={1}>{children}</S.TitleCountdown>
      )}
    </S.Container>
  )
}

export { Validate }
